export default __webpack_public_path__ + "static/media/ticker_collab_req01.fdd926bd.svg";